module.exports = __webpack_public_path__ + "img/passenger-add-update.b7a4020e.svg";